export default {
    translation: {
        "change to": "change to",
        "english": "english",
        "polish": "polish",
        "refresh page": "refresh page",
        "updatedBookDetails": "Updated Book Details",
        "submit": "Submit",
        "search": "Search",
        "areyousure": "Are you sure you want to sell the selected book?",
        "listbook": "List Book",
        "no": "No",
        "yes": "Yes",
        "sell": "Sell",
        "accessible": "Accessible",
        "number of available items": "Number of available items",
        "mybasket": "My Basket",
        "basket" : "Basket",
        "nocartitems": "No cart Items",
        "add-new-book": "Add New Book",
        "title": "Title",
        "pages": "Pages:",
        "addProduct": "Add product",
        "preview-new-book": "preview of the new book",
        "page-count": "Number of pages",
        "date-added": "Date added",
        "authors" : "Authors",
        "mainpage" : "Main Page",
        "addproduct" : "Add Product",
        "editproduct" : "Edit Product",
        "sellproduct" : "Sell Product",
        "add" : "Add",
        "edit" : "Edit",
        "sortby" : "Sort by",
        "booksshow" : "Number of available items",
        "showdetails" : "Show Details",
        "bookdetails" : "Book Details",
        "backtoprojects" : "Back to Projects"
    },
};